import { DirectionOfFeeType } from '@models/businessSettings/directionOfFees';
import { RadioGroupItem } from '../../atomic/atoms/radio-group/radio-group.component';

export const DirectionOfFeesOptions: RadioGroupItem<DirectionOfFeeType>[] = [
	{
		label: 'Trust ledger',
		value: DirectionOfFeeType.TRUST_LEDGER,
	},
	{
		label: 'Statement of account',
		value: DirectionOfFeeType.SOA,
	},
];
